import React from "react";
import { Container } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";

const Nineth = () => {
  return (
    <>
      <section className="last-mobileApp-section">
        <Container>
          <div className="top-text-after-last-mobileApp">
            <h2>
              QUESTIONS <span>YOU'D LIKE TO ASK</span>
            </h2>
          </div>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                1. How do your IT solutions improve supply chain visibility?
              </Accordion.Header>
              <Accordion.Body>
                Our real-time tracking and analytics enhance end-to-end
                visibility, enabling better decision-making and inventory
                management.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                2. Why are your offshore IT services cost-effective?
              </Accordion.Header>
              <Accordion.Body>
                We offer competitive pricing with high-quality solutions that
                optimize operations, reducing overall logistics costs.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                3. How do you ensure data security?
              </Accordion.Header>
              <Accordion.Body>
                We use robust encryption, secure cloud storage, and regular
                audits to protect your sensitive logistics data.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                4. Can you integrate with existing logistics systems?
              </Accordion.Header>
              <Accordion.Body>
                Yes, our customizable solutions seamlessly integrate with your
                current warehouse and transportation management systems.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>
                5. Do you offer 24/7 IT support?
              </Accordion.Header>
              <Accordion.Body>
                Our global team provides round-the-clock support to ensure
                continuous operations across all time zones.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Container>
      </section>
    </>
  );
};

export default Nineth;
